import styled from "styled-components";
import { NextButtonIcon } from "../../onboardingStepsStyles";

export const SelectPlanContainer = styled.div``;
export const SelectPlanHeader = styled.div`
  margin-bottom: 30px;
`;
export const HeaderSpan = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.main.textSecondary};

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
  @media screen and (max-width: 500px) {
    font-size: 12px;
  }
`;

export const NoCardRequiredDiv = styled.div`
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column-gap: 10px;
  padding: 8px 15px;
  margin-top: 20px;
  border-radius: 15px;
  background-color: ${({ theme }) => theme.colors.main.successLight};
  border: 2px solid ${({ theme }) => theme.colors.main.successMedium};

  @media screen and (max-width: 768px) {
    margin-left: auto;
    margin-right: auto;
  }
`;
export const NoCardRequiredText = styled.span`
  color: ${({ theme }) => theme.colors.main.successText};
  font-size: 15px;
  font-weight: 600;
`;

export const GetStartedButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column-gap: 2px;
  width: 85%;
  padding: ${({ isLoading }) => (isLoading ? "5px 20px" : "10px 20px")};
  border-radius: 8px;
  background: ${({ name, theme }) =>
    name === 'elite'
      ? theme.colors.main.successMedium
      : name === 'standard'
      ? '#4D94FF'
      : '#5D687E'};
  color: ${({ theme }) => theme.colors.main.white};
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  ${NextButtonIcon} {
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%);
  }

  &:hover {
    background-color: ${({ name }) =>
      name === 'elite'
        ? '#63aa67'
        : name === 'standard'
        ? '#3f86f0'
        : '#4f596d'};
    ${NextButtonIcon} {
      transform: translateX(5px);
      transition: transform 0.3s ease;
    }
  }
`;

export const PlanCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(auto, 330px));
  grid-column-gap: 40px;
  justify-content: flex-start;
  align-items: center;
  @media screen and (max-width: 1024px) {
    grid-template-columns: minmax(auto, 330px);
  }
  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 30px;
    justify-items: center;
  }
`;
export const SinglePlanCardContainer = styled.div`
  min-width: ${({ width }) => width ?? "300px"};
  min-height: 410px;
  padding: 35px;
  border-radius: 15px;
  background: ${({ name, theme }) =>
    name === 'elite'
      ? theme.colors.main.greenBackground
      : name === 'standard'
      ? theme.colors.main.blueBackground
      : theme.colors.main.playGrayLight};
`;
export const SinglePlanCardTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
`;
export const FeatureDivContainer = styled.div``;
export const SingleFeatureDiv = styled.div`
  display: flex;
  align-items: center;
  grid-column-gap: 10px;
  margin-bottom: 12px;
`;
